export default function(state = {}, action) {
  const typeMap = {
    MIC_HUB_PAGE_LOADING() {
      return {
        isLoading: true,
        micHubPage: action.micHubPage
      };
    },
    MIC_HUB_PAGE_LOADED() {
      return {
        isLoading: false,
        data: action.micHubPage
      };
    },
    MIC_HUB_PAGE_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.micHubPage.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
}
